module.exports = __webpack_public_path__ + "img/Banner.f619c65d.png";